module.exports = __webpack_public_path__ + "img/67.0fed56b3.jpg";